import{css}from'glamor';export default css({fill:'currentColor',width:'1em',height:'1em'}).toString();